import * as ActionTypes from "constants/ActionTypes";

export const setChapterListVisible = (visible) => ({
  type: ActionTypes.SET_CHAPTER_LIST_VISIBLE,
  visible,
});

export const setSlideshowGalleryToggle = (visible) => ({
  type: ActionTypes.SET_SLIDESHOW_GALLERY_TOGGLE,
  visible,
});

export const setSlideshowInfoToggle = (visible) => ({
  type: ActionTypes.SET_SLIDESHOW_INFO_TOGGLE,
  visible,
});
